import { SvgIconComponent } from '@mui/icons-material'
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline'
import ContentCopy from '@mui/icons-material/FileCopy'
import InsertDriveFileOutlinedIcon from '@mui/icons-material/InsertDriveFileOutlined'
import SpeedIcon from '@mui/icons-material/Speed'
import { List, ListItemButton, ListItemIcon, ListItemText } from '@mui/material'
import { AUTHORITIES } from 'config'
import useMode from 'hooks/useMode'
import { Link as RouterLink, useRouteLoaderData } from 'react-router-dom'

import type { ReactNode } from 'react'

interface ListItemLinkProps {
  icon: SvgIconComponent
  to: string
  testid: string
  children: ReactNode
}

const ListItemLink = ({ icon: Icon, to, testid, children }: ListItemLinkProps) => {
  return (
    <ListItemButton
      selected={false}
      role="menuitem"
      component={RouterLink}
      to={to}
      sx={{ py: 0.5 }}
      data-testid={testid}
    >
      <ListItemIcon sx={{ minWidth: 32 }}>
        <Icon />
      </ListItemIcon>
      {children}
    </ListItemButton>
  )
}

interface MenuConfig {
  link: string
  text: string
  icon: SvgIconComponent
  adminOnly?: boolean
  testid: string
}

const normalMenuConfig = [
  {
    link: '/normal/home',
    text: '文書一覧',
    icon: InsertDriveFileOutlinedIcon,
    testid: 'normal-side-menu-documents-list',
  },
  {
    link: '/normal/deleted',
    text: 'ごみ箱',
    icon: DeleteOutlineIcon,
    testid: 'normal-side-menu-deleted',
  },
  {
    link: '/normal/dashboard',
    text: 'ダッシュボード',
    icon: SpeedIcon,
    testid: 'normal-side-menu-dashboard',
  },
  {
    link: '/normal/log',
    text: '利用ログ',
    icon: ContentCopy,
    adminOnly: true,
    testid: 'normal-side-menu-usage-log',
  },
]

const verifyMenuConfig = [
  {
    link: '/verify/home',
    text: 'ベリファイタスク一覧',
    icon: InsertDriveFileOutlinedIcon,
    testid: 'verify-side-menu-documents-list',
  },
  {
    link: '/verify/deleted',
    text: 'ごみ箱(ベリファイ)',
    icon: DeleteOutlineIcon,
    testid: 'verify-side-menu-deleted',
  },
  {
    link: '/verify/dashboard',
    text: 'ダッシュボード',
    icon: SpeedIcon,
    testid: 'verify-side-menu-dashboard',
  },
  {
    link: '/verify/log',
    text: '利用ログ',
    icon: ContentCopy,
    adminOnly: true,
    testid: 'verify-side-menu-usage-log',
  },
]

export default function SideMenu() {
  const { mode } = useMode()
  const rootData = useRouteLoaderData('root') as any

  const menuConfig: MenuConfig[] = mode === 'verify' ? verifyMenuConfig : normalMenuConfig

  return (
    <List component="nav" aria-label="menu">
      {menuConfig.map(
        ({ link, text, icon, adminOnly, testid }) =>
          (!adminOnly || rootData?.profile?.authority === AUTHORITIES.ADMIN) && (
            <ListItemLink key={link} to={link} icon={icon} testid={testid}>
              <ListItemText primary={text} />
            </ListItemLink>
          ),
      )}
    </List>
  )
}
